
    import './styles.scoped.css';
    export default {
  "header-cell": "awsui_header-cell_1spae_1rkq4_93",
  "header-cell-sticky": "awsui_header-cell-sticky_1spae_1rkq4_105",
  "header-cell-stuck": "awsui_header-cell-stuck_1spae_1rkq4_108",
  "header-cell-variant-full-page": "awsui_header-cell-variant-full-page_1spae_1rkq4_108",
  "header-cell-hidden": "awsui_header-cell-hidden_1spae_1rkq4_111",
  "header-cell-sortable": "awsui_header-cell-sortable_1spae_1rkq4_114",
  "header-cell-resizable": "awsui_header-cell-resizable_1spae_1rkq4_126",
  "sorting-icon": "awsui_sorting-icon_1spae_1rkq4_130",
  "edit-icon": "awsui_edit-icon_1spae_1rkq4_137",
  "header-cell-content": "awsui_header-cell-content_1spae_1rkq4_143",
  "header-cell-fake-focus": "awsui_header-cell-fake-focus_1spae_1rkq4_172",
  "header-cell-disabled": "awsui_header-cell-disabled_1spae_1rkq4_190",
  "header-cell-sorted": "awsui_header-cell-sorted_1spae_1rkq4_190",
  "header-cell-text": "awsui_header-cell-text_1spae_1rkq4_204",
  "header-cell-text-wrap": "awsui_header-cell-text-wrap_1spae_1rkq4_204",
  "header-cell-ascending": "awsui_header-cell-ascending_1spae_1rkq4_210",
  "header-cell-descending": "awsui_header-cell-descending_1spae_1rkq4_211",
  "is-visual-refresh": "awsui_is-visual-refresh_1spae_1rkq4_221",
  "has-striped-rows": "awsui_has-striped-rows_1spae_1rkq4_232"
};
  